import { clientInstance } from "../config/config";

export let startAttemptAPI = async (quizId) => {
    return clientInstance.post(`/quiz-attempt/start/${quizId}`);
}

export let submitAnswerAPI = async (attemptId, questionId, answer) => {
    return clientInstance.put(`/quiz-attempt/${attemptId}/answer`, {
        questionId,
        answer
    });
}

export let submitAttemptAPI = async (attemptId, timeSpent) => {
    return clientInstance.put(`/quiz-attempt/${attemptId}/submit`, {
        timeSpent
    });
}

export let getMyAttemptsAPI = async () => {
    return clientInstance.get(`/quiz-attempt/my`);
}

export let getAttemptDetailsAPI = async (attemptId) => {
    return clientInstance.get(`/quiz-attempt/${attemptId}`);
}

export let getCompletedAttemptByQuizAPI = async (quizId) => {
    return clientInstance.get(`/quiz-attempt/quiz/${quizId}/completed`);
}

